import React from "react";

const RedeemBtn = ({
  buttonText,
  defaultData,
  customClass,
  buttonTextColour,
  buttonColour,
}) => {
  return (
    <div
      className={`mt-20 redeemBtn ${customClass ? customClass : ""}`}
      style={{
        backgroundColor:
          buttonColour !== "" ? buttonColour : defaultData.buttonColour,
        color:
          buttonTextColour !== ""
            ? buttonTextColour
            : defaultData.buttonTextColour,
      }}
    >
      <span>{buttonText !== "" ? buttonText : defaultData.buttonText}</span>
    </div>
  );
};

export default RedeemBtn;
